// Copyright (c) 2017 PlanGrid, Inc.

import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './fileViewerMessages';

const Error = () => (
  <div className="error-message">
    <p className="alert">
      <b>
        <FormattedMessage {...messages.NoPreviewAvailableForThisDocument} />
      </b>
    </p>
  </div>
);

export default Error;
